// Convert a number to its ordinal representation (1st, 2nd, 3rd, etc.)
function getOrdinal(num) {
    const number = parseInt(num);
    
    if (isNaN(number)) {
        return '1st';
    }
    
    // Handle special cases for 11th, 12th, 13th
    if (number % 100 >= 11 && number % 100 <= 13) {
        return number + 'th';
    }
    
    // Handle standard cases
    switch (number % 10) {
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
        default:
            return number + 'th';
    }
}

// Generate a smart agent name based on current agent count
export function generateAgentName(currentAgents = 0, isAdminPanelLaunch = false) {
    if (!isAdminPanelLaunch) {
        // Direct launch - use default name
        return 'My First Agent';
    }
    
    // Admin panel launch - use smart naming
    const nextAgentNumber = currentAgents + 1;
    const ordinal = getOrdinal(nextAgentNumber);
    return `My ${ordinal} Agent`;
}
